export const EditableProps = {
  props: {
    value: {
      type: [Object, Number, String, Boolean],
      default: null
    },

    id: {
      type: [Number, String],
      default: null
    },

    is_edit: {
      type: Boolean,
      default: false
    }
  },

  data: () => ({
    local_value: null
  }),

  watch: {
    value: {
      handler: function(val) {
        this.local_value = val;
      },
      deep: true,
      immediate: true
    }
  }
};
